import { Box, Typography } from "@mui/material";
import { NotificationType } from "../../constants/appConstants";
import { useNavigate } from "react-router-dom";
import { NotificationFullData } from "../../layout/UserNotification";
import useThemeStore from "../../services/store/useThemeStore";
import { DateNTime } from "../../utils/dateTime";
import { wrapperStyles } from "./BookingStarted";
import { contentStyles } from "./BookingStarted";
import { titleStyles } from "./BookingStarted";

const BookingAcceptedRejected = ({
  notification,
}: {
  notification: NotificationFullData;
}) => {
  const isAccepted =
    notification.notification_type === NotificationType.BookingAccepted;

  const navigate = useNavigate();
  const { darkMode } = useThemeStore();

  const handleClick = () => {
    navigate("/sessions");
  };

  return (
    <Box onClick={handleClick} sx={wrapperStyles(darkMode)}>
      <Box sx={contentStyles}>
        <Typography
          sx={{
            ...titleStyles(darkMode),
            color: isAccepted
              ? darkMode
                ? "#22c55e"
                : "#059669" // green for accepted
              : darkMode
                ? "#dc2626"
                : "#b91c1c", // red for rejected
          }}
        >
          {notification?.title ??
            (isAccepted ? "Booking Accepted" : "Booking Rejected")}
        </Typography>
        <Typography
          sx={{
            color: darkMode ? "#e5e7eb" : "#374151",
            font: "var(--body-xs)",
            fontWeight: 400,
          }}
        >
          {notification.message}
        </Typography>
        {notification?.created_at && (
          <Typography
            sx={{
              font: "var(--semibold-xxs)",
              color: darkMode ? "#d1d5db" : "#4b5563",
              fontWeight: 500,
            }}
          >
            {DateNTime.formatRelative(notification.created_at)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default BookingAcceptedRejected;
